"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionCardBody = void 0;
const react_1 = __importDefault(require("react"));
const ActionCard_styles_1 = require("../../ActionCard.styles");
/** This is used at the top-level of the ActionCard
 * It allows us to only render a certain style of border around the body
 */
const ActionCardBody = ({ colour, children, }) => {
    return react_1.default.createElement(ActionCard_styles_1.StyledColouredCard, { colour: colour }, children);
};
exports.ActionCardBody = ActionCardBody;
exports.ActionCardBody.displayName = "ActionCardBody";
//# sourceMappingURL=ActionCardBody.js.map